import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { TreeViewModule } from '../treeview/treeview.module';
import { AddGroupPopupComponent } from './add-group-popup/add-group-popup.component';
import { AddUserPopupComponent } from './add-user-popup/add-user-popup.component';
import { GroupMemberListComponent } from './group-member-list/group-member-list.component';
import { InheritedPermPopupComponent } from './inherited-perm-popup/inherited-perm-popup.component';
import { PermissionsEditorComponent } from './permissions-editor.component';
import { PermissionsLegendComponent } from './permissions-legend/permissions-legend.component';
import { PermissionsListComponent } from './permissions-list';
import { TreeviewGenericPermissionsComponent } from './treeview-generic-permissions';

@NgModule({
    imports: [CommonModule, FormsModule, TranslateModule, TwcModule, TreeViewModule],
    declarations: [
        PermissionsEditorComponent,
        PermissionsListComponent,
        GroupMemberListComponent,
        AddGroupPopupComponent,
        AddUserPopupComponent,
        InheritedPermPopupComponent,
        TreeviewGenericPermissionsComponent,
        PermissionsLegendComponent,
    ],
    exports: [PermissionsEditorComponent, PermissionsListComponent, TreeviewGenericPermissionsComponent, PermissionsLegendComponent],
})
export class PermissionsEditorModule {}
